import { render, staticRenderFns } from "./mer.vue?vue&type=template&id=769285c3&"
import script from "./mer.vue?vue&type=script&lang=js&"
export * from "./mer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports